import { render, staticRenderFns } from "./PortfolioStockLotMobile.vue?vue&type=template&id=2388f52c&scoped=true&"
import script from "./PortfolioStockLotMobile.vue?vue&type=script&lang=js&"
export * from "./PortfolioStockLotMobile.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioStockLotMobile.vue?vue&type=style&index=0&id=2388f52c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2388f52c",
  null
  
)

export default component.exports